export default "-- ClickBench Q4\nselect count(distinct userid)\nfrom hits;";